import LeftPart from "src/components/leftPart/LeftPart";
import CustomInView from "src/components/ui/other/customInView/CustomInView";
import MainStyles from "src/pages/main/MainStyles";
import {Link} from "react-router-dom";

function Main() {
  return (
    <MainStyles>
      <div className="content">
        <LeftPart/>
        <div className="rightPart">
          <CustomInView classes="imageWrapper">
            <img src="/images/hand-with-phone.png" alt=""/>
          </CustomInView>
        </div>
      </div>
    </MainStyles>
  );
}

export default Main;
